import { useEffect, useMemo, useRef, useState } from "react";
import moment from "moment";
import InputPicker from "./InputPicker";
import useWebData from "../hooks/useWebData";
import useReservation from "../hooks/useReservationData";
import { getLocationOpenHours } from "../services/locationOpenHour";
import { branchTimezone } from "../utils/summaryCalculation";
import axios from "axios";
import { baseURL, tenantId } from "../config/api";
import useConfirm from "../hooks/useConfirm";
import { useNavigate } from "react-router-dom";
import { CustomDateField } from "./CustomDateField";
import Loader from "../icon/Loader";


export const HeaderSection = () => {
    const navigate = useNavigate();
    const { webData }: any = useWebData();
    const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
    const {
        branchId,
        setBranchId,
        branches,
        locationOpenHourOfParticularBranch,
        setLocationOpenHourOfParticularBranch,
        formattedCreatedAt,
        pickupLocationId,
        setPickupLocationId,
        setReturnLocationId,
        pickupDate,
        setPickupDate,
        returnDate,
        setReturnDate,
        pickupTime,
        setPickupTime,
        returnTime,
        setReturnTime,
        locations,
        locationDataIsLoaded,
        setLocationFeeAmount,
        setTaxAmount,
        setMandatoryAdditionalChargesAmount,
        setGovernmentTaxAmount,
        setCurrentPage,
        setIsNavigate,
        returnToDifferent,
        setReturnToDifferent
    }: any = useReservation();
    const [locationOptions, setLocationOptions] = useState<any[]>([]);
    const [pickupSearch, setPickupSearch] = useState<string>('');
    const [returnSearch, setReturnSearch] = useState<string>('');
    const [pickupIsFocused, setPickupIsFocused] = useState<boolean>(false);
    const [pickupFilteredOptions, setPickupFilteredOptions] = useState<any[]>([]);
    const pickupWrapperRef = useRef<HTMLDivElement | null>(null);
    const [returnIsFocused, setReturnIsFocused] = useState<boolean>(false);
    const [returnFilteredOptions, setReturnFilteredOptions] = useState<any[]>([]);
    const returnWrapperRef = useRef<HTMLDivElement | null>(null);
    const pickupTimeRef = useRef<HTMLInputElement>(null);
    const returnTimeRef = useRef<HTMLInputElement>(null);
    const UpdateTimezone = branchTimezone(formattedCreatedAt);
    const [isValid, setIsValid] = useState<boolean>(false);
    const [returnTimeMessage, setReturnTimeMessage] = useState<string>("");
    const [minBookingMessage, setMinBookingMessage] = useState<string>("");

    useEffect(() => {
        setPickupFilteredOptions(locationOptions);
        setReturnFilteredOptions(locationOptions);
    }, [locationOptions])

    useEffect(() => {
        if (!returnToDifferent) {
            setReturnLocationId(pickupLocationId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [returnToDifferent])

    useEffect(() => {
        const handler = (e: any) => {
            if (pickupWrapperRef.current && !pickupWrapperRef.current.contains(e.target)) {
                setPickupIsFocused(false);
            }
        };
        document.addEventListener('mousedown', handler);
        return () => {
            document.removeEventListener('mousedown', handler);
        };
    }, []);

    useEffect(() => {
        const handler = (e: any) => {
            if (returnWrapperRef.current && !returnWrapperRef.current.contains(e.target)) {
                setReturnIsFocused(false);
            }
        };
        document.addEventListener('mousedown', handler);
        return () => {
            document.removeEventListener('mousedown', handler);
        };
    }, []);

    useEffect(() => {
        if (locations.length > 0) {
            const result = locations.map((item: any) => {
                return {
                    value: item?.id,
                    label: `${[item?.street, item?.city, item?.state].filter(Boolean).join(', ')} (${item?.locationName || ''})`,
                    branchId: item?.branchId,
                    locationFee: item?.locationFee,
                    taxLabel: item?.taxLabel,
                    tax: item?.tax,
                    mandatoryAdditionalCharges: item?.mandatoryAdditionalCharges,
                    governmentTax: item?.governmentTax
                }
            })

            setLocationOptions(result)
            setPickupFilteredOptions(result);
            setReturnFilteredOptions(result)
        }
        else {
            setLocationOptions([])
            setPickupFilteredOptions([]);
            setReturnFilteredOptions([])
        }
    }, [locations])

    useEffect(() => {
        const results = locationOptions.filter((opt) =>
            opt.label.toLowerCase().includes(pickupSearch.toLowerCase())
        );
        setPickupFilteredOptions(results);
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pickupSearch]);

    useEffect(() => {
        const results = locationOptions.filter((opt) =>
            opt.label.toLowerCase().includes(returnSearch.toLowerCase())
        );
        setReturnFilteredOptions(results);
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [returnSearch]);


    useEffect(() => {
        if (parseInt(branchId) > 0) {
            getLocationOpenHours(tenantId)
                .then(data => {
                    setLocationOpenHourOfParticularBranch(data?.filter((item: any) => item.branchId === parseInt(branchId) && (new Date(item.startDate) <= new Date() && new Date(item.endDate) >= new Date())));
                })
                .catch((error) => {
                    console.log(error);
                })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [branchId]);

    useEffect(() => {
        if (locationOpenHourOfParticularBranch.length !== 0) {
            setTimeWithOpenHour(new Date(pickupDate), true);
            setTimeWithOpenHour(new Date(returnDate), false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [locationOpenHourOfParticularBranch])


    const setTimeWithOpenHour = (date: Date, isPickupTime: boolean) => {
        const currentTime = new Date(UpdateTimezone);
        switch (date.getDay()) {
            case 0:
                if (locationOpenHourOfParticularBranch[0]?.sundayOpenTime) {
                    if (isPickupTime) {
                        if (moment(moment(currentTime)?.format('HH:mm'), 'HH:mm')?.isBefore(moment(locationOpenHourOfParticularBranch[0]?.sundayOpenTime, 'HH:mm'))) {
                            setPickupTime(locationOpenHourOfParticularBranch[0]?.sundayOpenTime);
                        }
                    } else {
                        setReturnTime(locationOpenHourOfParticularBranch[0]?.sundayOpenTime);
                    }
                }
                break;
            case 1:
                if (locationOpenHourOfParticularBranch[0]?.mondayOpenTime) {
                    if (isPickupTime) {
                        if (moment(moment(currentTime)?.format('HH:mm'), 'HH:mm')?.isBefore(moment(locationOpenHourOfParticularBranch[0]?.mondayOpenTime, 'HH:mm'))) {
                            setPickupTime(locationOpenHourOfParticularBranch[0]?.mondayOpenTime);
                        }
                    } else {
                        setReturnTime(locationOpenHourOfParticularBranch[0]?.mondayOpenTime);
                    }
                }
                break;
            case 2:
                if (locationOpenHourOfParticularBranch[0]?.tuesdayOpenTime) {
                    if (isPickupTime) {
                        if (moment(moment(currentTime)?.format('HH:mm'), 'HH:mm')?.isBefore(moment(locationOpenHourOfParticularBranch[0]?.tuesdayOpenTime, 'HH:mm'))) {
                            setPickupTime(locationOpenHourOfParticularBranch[0]?.tuesdayOpenTime);
                        }
                    } else {
                        setReturnTime(locationOpenHourOfParticularBranch[0]?.tuesdayOpenTime);
                    }
                }
                break;
            case 3:
                if (locationOpenHourOfParticularBranch[0]?.wednesdayOpenTime) {
                    if (isPickupTime) {
                        if (moment(moment(currentTime)?.format('HH:mm'), 'HH:mm')?.isBefore(moment(locationOpenHourOfParticularBranch[0]?.wednesdayOpenTime, 'HH:mm'))) {
                            setPickupTime(locationOpenHourOfParticularBranch[0]?.wednesdayOpenTime);
                        }
                    } else {
                        setReturnTime(locationOpenHourOfParticularBranch[0]?.wednesdayOpenTime);
                    }
                }
                break;
            case 4:
                if (locationOpenHourOfParticularBranch[0]?.thursdayOpenTime) {
                    if (isPickupTime) {
                        if (moment(moment(currentTime)?.format('HH:mm'), 'HH:mm')?.isBefore(moment(locationOpenHourOfParticularBranch[0]?.thursdayOpenTime, 'HH:mm'))) {
                            setPickupTime(locationOpenHourOfParticularBranch[0]?.thursdayOpenTime);
                        }
                    } else {
                        setReturnTime(locationOpenHourOfParticularBranch[0]?.thursdayOpenTime);
                    }
                }
                break;
            case 5:
                if (locationOpenHourOfParticularBranch[0]?.fridayOpenTime) {
                    if (isPickupTime) {
                        if (moment(moment(currentTime)?.format('HH:mm'), 'HH:mm')?.isBefore(moment(locationOpenHourOfParticularBranch[0]?.fridayOpenTime, 'HH:mm'))) {
                            setPickupTime(locationOpenHourOfParticularBranch[0]?.fridayOpenTime);
                        }
                    } else {
                        setReturnTime(locationOpenHourOfParticularBranch[0]?.fridayOpenTime);
                    }
                }
                break;
            case 6:
                if (locationOpenHourOfParticularBranch[0]?.saturdayOpenTime) {
                    if (isPickupTime) {
                        if (moment(moment(currentTime)?.format('HH:mm'), 'HH:mm')?.isBefore(moment(locationOpenHourOfParticularBranch[0]?.saturdayOpenTime, 'HH:mm'))) {
                            setPickupTime(locationOpenHourOfParticularBranch[0]?.saturdayOpenTime);
                        }
                    } else {
                        setReturnTime(locationOpenHourOfParticularBranch[0]?.saturdayOpenTime);
                    }
                }
                break;
        }
    }

    useEffect(() => {
        if (new Date(pickupDate)?.getTime() === new Date(returnDate)?.getTime() && returnTime <= pickupTime) {
            setIsValid(false);
            setReturnTimeMessage("Return Time must greater than pickup Time");
        }
        else {
            setIsValid(true);
            setReturnTimeMessage("");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pickupDate, pickupTime, returnDate, returnTime]);

    const selectedBranch = useMemo(() => {
        return branches?.find((branch: any) => branch.id === parseInt(branchId));
    }, [branchId, branches]);

    const minAllowedHoursToBook = selectedBranch ? selectedBranch?.minAllowedHoursToBook : 0;

    useEffect(() => {
        const pickupDateTime = new Date(`${pickupDate}T${pickupTime}`);
        const returnDateTime = new Date(`${returnDate}T${returnTime}`);

        const timeDifferenceInMs = returnDateTime.getTime() - pickupDateTime.getTime();
        const timeDifferenceInHours = timeDifferenceInMs / (1000 * 60 * 60);

        if (new Date(pickupDate).getTime() === new Date(returnDate).getTime()) {
            if (timeDifferenceInHours < minAllowedHoursToBook) {
                setMinBookingMessage(
                    `The minimum booking duration is ${minAllowedHoursToBook} hours.`
                );
                setIsValid(false);
            } else {
                setMinBookingMessage("");
                setIsValid(true);
            }
        } else {
            setMinBookingMessage("");
            setIsValid(true);
        }
    }, [pickupDate, pickupTime, returnDate, returnTime, minAllowedHoursToBook]);

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (
            new Date(locationOpenHourOfParticularBranch[0]?.startDate) <=
            new Date(pickupDate.replaceAll("-", "/")) &&
            new Date(locationOpenHourOfParticularBranch[0]?.endDate) >=
            new Date(returnDate.replaceAll("-", "/"))
        ) {
            if (isValid && moment(pickupDate, "YYYY-MM-DD", true).isValid() && moment(returnDate, "YYYY-MM-DD", true).isValid()) {
                const pickupDateTime = moment(`${pickupDate}T${pickupTime}`).format('YYYY-MM-DDTHH:mm');
                const returnDateTime = moment(`${returnDate}T${returnTime}`).format('YYYY-MM-DDTHH:mm');
                axios.get(`${baseURL}blockedDay/GetBlockedDaysByStartDateAndEndDate/${pickupDateTime},${returnDateTime}`, {
                    headers: {
                        'X-Tenant-ID': tenantId,
                    }
                })
                    .then((res) => {
                        if (res.data.length > 0) {
                            if (res.data[0]?.isAllDay) {
                                setConfirmData({
                                    title: `We are closed on ${moment(res.data[0]?.startDate.split('T')[0]).format(webData?.dateFormat?.replace(/yyyy/g, 'YYYY'))
                                        === moment(pickupDate).format(webData?.dateFormat?.replace(/yyyy/g, 'YYYY'))
                                        ? moment(pickupDate).format(webData?.dateFormat?.replace(/yyyy/g, 'YYYY'))
                                        : moment(res.data[0]?.startDate.split('T')[0]).format(webData?.dateFormat?.replace(/yyyy/g, 'YYYY'))
                                            === moment(returnDate).format(webData?.dateFormat?.replace(/yyyy/g, 'YYYY'))
                                            ? moment(returnDate).format(webData?.dateFormat?.replace(/yyyy/g, 'YYYY'))
                                            : moment(pickupDate).format(webData?.dateFormat?.replace(/yyyy/g, 'YYYY'))}`,
                                    confirmBtn: "Ok",
                                    isConfirm: (callback: any) => {

                                        callback();
                                    }
                                });
                                setConfirmPopup(true);
                            }
                            else {
                                const df = webData?.dateFormat?.replace(/yyyy/g, "YYYY") || "DD/MM/YYYY";
                                setConfirmData({
                                    title: `We are closed on ${moment(res.data[0]?.startDate?.split("T")?.[0]).format(df) ===
                                        moment(pickupDate).format(df)
                                        ? moment(pickupDate).format(df)
                                        : moment(res.data[0]?.startDate?.split("T")?.[0]).format(df) ===
                                            moment(returnDate).format(df)
                                            ? moment(returnDate).format(df)
                                            : ""
                                        } between ${moment(
                                            `${res.data[0]?.startDate?.split("T")?.[0]}T${res.data[0]?.startTime}`,
                                            [`YYYY-MM-DDTHH:mm`, `${df}THH:mm`],
                                            true
                                        ).format("hh:mm a")
                                        } to ${moment(
                                            `${res.data[0]?.startDate?.split("T")?.[0]}T${res.data[0]?.endTIme}`,
                                            [`YYYY-MM-DDTHH:mm`, `${df}THH:mm`],
                                            true
                                        ).format("hh:mm a")
                                        }`,
                                    confirmBtn: "Ok",
                                    isConfirm: (callback: any) => {
                                        callback();
                                    }

                                });
                                setConfirmPopup(true);
                            }
                        }
                        else {
                            let pickupDateMessages = "";
                            let returnDateMessages = "";
                            let pickupTimeMessages = "";
                            let returnTimeMessages = "";


                            switch (new Date(pickupDate.replaceAll("-", "/")).getDay()) {
                                case 0:
                                    if (locationOpenHourOfParticularBranch[0].isSundayOpen) {
                                        pickupDateMessages = "";
                                        if (
                                            locationOpenHourOfParticularBranch[0].sundayOpenTime <=
                                            pickupTime &&
                                            locationOpenHourOfParticularBranch[0].sundayCloseTime >=
                                            pickupTime
                                        ) {
                                            pickupTimeMessages = "";
                                        } else {
                                            pickupTimeMessages =
                                                "Office on Sunday is open from " +
                                                moment(locationOpenHourOfParticularBranch[0].sundayOpenTime, "HH:mm").format("hh:mm a") +
                                                " to " +
                                                moment(locationOpenHourOfParticularBranch[0].sundayCloseTime, "HH:mm").format("hh:mm a");
                                        }
                                    } else {
                                        pickupDateMessages = "Office is closed on Sunday";
                                    }
                                    break;
                                case 1:
                                    if (locationOpenHourOfParticularBranch[0].isMondayOpen) {
                                        pickupDateMessages = "";
                                        if (
                                            locationOpenHourOfParticularBranch[0].mondayOpenTime <=
                                            pickupTime &&
                                            locationOpenHourOfParticularBranch[0].mondayCloseTime >=
                                            pickupTime
                                        ) {
                                            pickupTimeMessages = "";
                                        } else {
                                            pickupTimeMessages = "Office on Monday is open from " +
                                                moment(locationOpenHourOfParticularBranch[0].mondayOpenTime, "HH:mm").format("hh:mm a") +
                                                " to " +
                                                moment(locationOpenHourOfParticularBranch[0].mondayCloseTime, "HH:mm").format("hh:mm a");
                                        }
                                    } else {
                                        pickupDateMessages = "Office is closed on Monday";
                                    }
                                    break;
                                case 2:
                                    if (locationOpenHourOfParticularBranch[0].isTuesdayOpen) {
                                        pickupDateMessages = "";
                                        if (
                                            locationOpenHourOfParticularBranch[0].tuesdayOpenTime <=
                                            pickupTime &&
                                            locationOpenHourOfParticularBranch[0].tuesdayCloseTime >=
                                            pickupTime
                                        ) {
                                            pickupTimeMessages = "";
                                        } else {
                                            pickupTimeMessages =
                                                "Office on Tuesday is open from " +
                                                moment(locationOpenHourOfParticularBranch[0].tuesdayOpenTime, "HH:mm").format("hh:mm a") +
                                                " to " +
                                                moment(locationOpenHourOfParticularBranch[0].tuesdayCloseTime, "HH:mm").format("hh:mm a");
                                        }
                                    } else {
                                        pickupDateMessages = "Office is closed on Tuesday";
                                    }
                                    break;
                                case 3:
                                    if (locationOpenHourOfParticularBranch[0].isWednesdayOpen) {
                                        pickupDateMessages = "";
                                        if (
                                            locationOpenHourOfParticularBranch[0].wednesdayOpenTime <=
                                            pickupTime &&
                                            locationOpenHourOfParticularBranch[0].wednesdayCloseTime >=
                                            pickupTime
                                        ) {
                                            pickupTimeMessages = "";
                                        } else {
                                            pickupTimeMessages =
                                                "Office on Wednesday is open from " +
                                                moment(locationOpenHourOfParticularBranch[0].wednesdayOpenTime, "HH:mm").format("hh:mm a") +
                                                " to " +
                                                moment(locationOpenHourOfParticularBranch[0].wednesdayCloseTime, "HH:mm").format("hh:mm a");
                                        }
                                    } else {
                                        pickupDateMessages = "Office is closed on Wednesday";
                                    }
                                    break;
                                case 4:
                                    if (locationOpenHourOfParticularBranch[0].isThursdayOpen) {
                                        pickupDateMessages = "";
                                        if (
                                            locationOpenHourOfParticularBranch[0].thursdayOpenTime <=
                                            pickupTime &&
                                            locationOpenHourOfParticularBranch[0].thursdayCloseTime >=
                                            pickupTime
                                        ) {
                                            pickupTimeMessages = "";
                                        } else {
                                            pickupTimeMessages =
                                                "Office on Thursday is open from " +
                                                moment(locationOpenHourOfParticularBranch[0].thursdayOpenTime, "HH:mm").format("hh:mm a") +
                                                " to " +
                                                moment(locationOpenHourOfParticularBranch[0].thursdayCloseTime, "HH:mm").format("hh:mm a");
                                        }
                                    } else {
                                        pickupDateMessages = "Office is closed on Thursday";
                                    }
                                    break;
                                case 5:
                                    if (locationOpenHourOfParticularBranch[0].isFridayOpen) {
                                        pickupDateMessages = "";
                                        if (
                                            locationOpenHourOfParticularBranch[0].fridayOpenTime <=
                                            pickupTime &&
                                            locationOpenHourOfParticularBranch[0].fridayCloseTime >=
                                            pickupTime
                                        ) {
                                            pickupTimeMessages = "";
                                        } else {
                                            pickupTimeMessages =
                                                "Office on Friday is open from " +
                                                moment(locationOpenHourOfParticularBranch[0].fridayOpenTime, "HH:mm").format("hh:mm a") +
                                                " to " +
                                                moment(locationOpenHourOfParticularBranch[0].fridayCloseTime, "HH:mm").format("hh:mm a");
                                        }
                                    } else {
                                        pickupDateMessages = "Office is closed on Friday";
                                    }
                                    break;
                                case 6:
                                    if (locationOpenHourOfParticularBranch[0].isSaturdayOpen) {
                                        pickupDateMessages = "";
                                        if (
                                            locationOpenHourOfParticularBranch[0].saturdayOpenTime <=
                                            pickupTime &&
                                            locationOpenHourOfParticularBranch[0].saturdayCloseTime >=
                                            pickupTime
                                        ) {
                                            pickupTimeMessages = "";
                                        } else {
                                            pickupTimeMessages =
                                                "Office on Saturday is open from " +
                                                moment(locationOpenHourOfParticularBranch[0].saturdayOpenTime, "HH:mm").format("hh:mm a") +
                                                " to " +
                                                moment(locationOpenHourOfParticularBranch[0].saturdayCloseTime, "HH:mm").format("hh:mm a");
                                        }
                                    } else {
                                        pickupDateMessages = "Office is closed on Saturday";
                                    }
                                    break;
                            }

                            switch (new Date(returnDate.replaceAll("-", "/")).getDay()) {
                                case 0:
                                    if (locationOpenHourOfParticularBranch[0].isSundayOpen) {
                                        returnDateMessages = "";
                                        if (
                                            locationOpenHourOfParticularBranch[0].sundayOpenTime <=
                                            returnTime &&
                                            locationOpenHourOfParticularBranch[0].sundayCloseTime >=
                                            returnTime
                                        ) {
                                            returnTimeMessages = "";
                                        } else {
                                            returnTimeMessages =
                                                "Office on Sunday is open from " +
                                                moment(locationOpenHourOfParticularBranch[0].sundayOpenTime, "HH:mm").format("hh:mm a") +
                                                " to " +
                                                moment(locationOpenHourOfParticularBranch[0].sundayCloseTime, "HH:mm").format("hh:mm a");
                                        }
                                    } else {
                                        returnDateMessages = "Office is closed on Sunday";
                                    }
                                    break;
                                case 1:
                                    if (locationOpenHourOfParticularBranch[0].isMondayOpen) {
                                        returnDateMessages = "";
                                        if (
                                            locationOpenHourOfParticularBranch[0].mondayOpenTime <=
                                            returnTime &&
                                            locationOpenHourOfParticularBranch[0].mondayCloseTime >=
                                            returnTime
                                        ) {
                                            returnTimeMessages = "";
                                        } else {
                                            returnTimeMessages =
                                                "Office on Monday is open from " +
                                                moment(locationOpenHourOfParticularBranch[0].mondayOpenTime, "HH:mm").format("hh:mm a") +
                                                " to " +
                                                moment(locationOpenHourOfParticularBranch[0].mondayCloseTime, "HH:mm").format("hh:mm a");
                                        }
                                    } else {
                                        returnDateMessages = "Office is closed on Monday";
                                    }
                                    break;
                                case 2:
                                    if (locationOpenHourOfParticularBranch[0].isTuesdayOpen) {
                                        returnDateMessages = "";
                                        if (
                                            locationOpenHourOfParticularBranch[0].tuesdayOpenTime <=
                                            returnTime &&
                                            locationOpenHourOfParticularBranch[0].tuesdayCloseTime >=
                                            returnTime
                                        ) {
                                            returnTimeMessages = "";
                                        } else {
                                            returnTimeMessages =
                                                "Office on Tuesday is open from " +
                                                moment(locationOpenHourOfParticularBranch[0].tuesdayOpenTime, "HH:mm").format("hh:mm a") +
                                                " to " +
                                                moment(locationOpenHourOfParticularBranch[0].tuesdayCloseTime, "HH:mm").format("hh:mm a");
                                        }
                                    } else {
                                        returnDateMessages = "Office is closed on Tuesday";
                                    }
                                    break;
                                case 3:
                                    if (locationOpenHourOfParticularBranch[0].isWednesdayOpen) {
                                        returnDateMessages = "";
                                        if (
                                            locationOpenHourOfParticularBranch[0].wednesdayOpenTime <=
                                            returnTime &&
                                            locationOpenHourOfParticularBranch[0].wednesdayCloseTime >=
                                            returnTime
                                        ) {
                                            returnTimeMessages = "";
                                        } else {
                                            returnTimeMessages =
                                                "Office on Wednesday is open from " +
                                                moment(locationOpenHourOfParticularBranch[0].wednesdayOpenTime, "HH:mm").format("hh:mm a") +
                                                " to " +
                                                moment(locationOpenHourOfParticularBranch[0].wednesdayCloseTime, "HH:mm").format("hh:mm a");
                                        }
                                    } else {
                                        returnDateMessages = "Office is closed on Wednesday";
                                    }
                                    break;
                                case 4:
                                    if (locationOpenHourOfParticularBranch[0].isThursdayOpen) {
                                        returnDateMessages = "";
                                        if (
                                            locationOpenHourOfParticularBranch[0].thursdayOpenTime <=
                                            returnTime &&
                                            locationOpenHourOfParticularBranch[0].thursdayCloseTime >=
                                            returnTime
                                        ) {
                                            returnTimeMessages = "";
                                        } else {
                                            returnTimeMessages =
                                                "Office on Thursday is open from " +
                                                moment(locationOpenHourOfParticularBranch[0].thursdayOpenTime, "HH:mm").format("hh:mm a") +
                                                " to " +
                                                moment(locationOpenHourOfParticularBranch[0].thursdayCloseTime, "HH:mm").format("hh:mm a");
                                        }
                                    } else {
                                        returnDateMessages = "Office is closed on Thursday";
                                    }
                                    break;
                                case 5:
                                    if (locationOpenHourOfParticularBranch[0].isFridayOpen) {
                                        returnDateMessages = "";
                                        if (
                                            locationOpenHourOfParticularBranch[0].fridayOpenTime <=
                                            returnTime &&
                                            locationOpenHourOfParticularBranch[0].fridayCloseTime >=
                                            returnTime
                                        ) {
                                            returnTimeMessages = "";
                                        } else {
                                            returnTimeMessages =
                                                "Office on Friday is open from " +
                                                moment(locationOpenHourOfParticularBranch[0].fridayOpenTime, "HH:mm").format("hh:mm a") +
                                                " to " +
                                                moment(locationOpenHourOfParticularBranch[0].fridayCloseTime, "HH:mm").format("hh:mm a");
                                        }
                                    } else {
                                        returnDateMessages = "Office is closed on Friday";
                                    }
                                    break;
                                case 6:
                                    if (locationOpenHourOfParticularBranch[0].isSaturdayOpen) {
                                        returnDateMessages = "";
                                        if (
                                            locationOpenHourOfParticularBranch[0].saturdayOpenTime <=
                                            returnTime &&
                                            locationOpenHourOfParticularBranch[0].saturdayCloseTime >=
                                            returnTime
                                        ) {
                                            returnTimeMessages = "";
                                        } else {
                                            returnTimeMessages =
                                                "Office on Saturday is open from " +
                                                moment(locationOpenHourOfParticularBranch[0].saturdayOpenTime, "HH:mm").format("hh:mm a") +
                                                " to " +
                                                moment(locationOpenHourOfParticularBranch[0].saturdayCloseTime, "HH:mm").format("hh:mm a");
                                        }
                                    } else {
                                        returnDateMessages = "Office is closed on Saturday";
                                    }
                                    break;
                            }


                            if (pickupDateMessages === "" &&
                                pickupTimeMessages === "" &&
                                returnDateMessages === "" &&
                                returnTimeMessages === "" &&
                                minBookingMessage === "") {
                                setCurrentPage(1);
                                setIsNavigate(true);
                                navigate("/reservation")
                            }
                            else {
                                setConfirmPopup(true);
                                setConfirmData({
                                    title: `${pickupDateMessages} ${pickupTimeMessages} ${returnDateMessages} ${returnTimeMessages}`,
                                    confirmBtn: "Ok",
                                    isConfirm: (callback: any) => {

                                        callback();
                                    }
                                });
                            }

                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    })
            }
            else {
                setConfirmPopup(true);
                setConfirmData({
                    title: `Please fill valid Information`,
                    confirmBtn: "Ok",
                    isConfirm: (callback: any) => {

                        callback();
                    }
                });
            }
        }
        else {
            setConfirmPopup(true);
            setConfirmData({
                title: `We are closed on ${moment(pickupDate, webData?.dateFormat?.replace(/yyyy/g, 'YYYY'), true).format(webData?.dateFormat?.replace(/yyyy/g, 'YYYY'))} 
and ${moment(returnDate, webData?.dateFormat?.replace(/yyyy/g, 'YYYY'), true).format(webData?.dateFormat?.replace(/yyyy/g, 'YYYY'))}`,
                confirmBtn: "Ok",
                isConfirm: (callback: any) => {

                    callback();
                }
            });
        }
    }

    return (
        <header
            className="min-h-screen bg-cover bg-center flex justify-center items-center relative px-4 pb-10 pt-[140px] mt-10"
            style={{
                //change from dynamic background to static
                //backgroundImage: `url(${webData?.websiteIndexPageImage})` 
                backgroundImage: "url('/images/jjvansbg.jpg')"
            }}
        >
            <div className="absolute inset-0 bg-black bg-opacity-40" />

            <div className="relative bg-white rounded-2xl px-6 md:px-10 py-8 shadow-lg w-full max-w-6xl">
                <form className="space-y-6" onSubmit={handleSubmit}>
                    {/* Pickup & Return Inputs */}
                    <div className="flex flex-col md:flex-row gap-4">
                        {/* Pickup Location */}
                        <div className="w-full space-y-2 relative" ref={pickupWrapperRef}>
                            <label className="text-sm font-semibold">
                                Pickup Location {returnToDifferent ? "" : "and Return Location"}
                            </label>
                            <div className="w-full border rounded-lg px-1 text-sm flex items-center">
                                <input
                                    type="text"
                                    placeholder="Search Location"
                                    className="w-full outline-none px-4 py-3"
                                    value={pickupSearch}
                                    onChange={(e) => setPickupSearch(e.target.value)}
                                    onFocus={() => setPickupIsFocused(true)}
                                    required
                                />
                                {
                                    pickupSearch && (
                                        <button
                                            onClick={() => setPickupSearch("")}
                                            className="text-black mx-2"
                                        >
                                            <span className="material-symbols-outlined text-lg">
                                                close
                                            </span>
                                        </button>
                                    )
                                }

                                {
                                    !locationDataIsLoaded && (
                                        <button
                                            type="button"
                                            className="mx-2"
                                        >
                                            <Loader />
                                        </button>                                       
                                    )
                                }
                            </div>

                            {
                                pickupIsFocused && !locationDataIsLoaded && (
                                    <ul className="absolute z-10 mt-1 w-full bg-white border rounded-md shadow-lg max-h-52 overflow-y-auto text-sm">              
                                        <li className={`p-3 cursor-pointer bg-gray-100 border-b hover:bg-white hover:font-semibold ${webData?.hoverPrimaryTextColor}`}>
                                            Loading…
                                        </li>
                                    </ul>
                                )
                            }

                            {pickupIsFocused && pickupFilteredOptions.length > 0 && (
                                <ul className="absolute z-10 mt-1 w-full bg-white border rounded-md shadow-lg max-h-52 overflow-y-auto text-sm">
                                    {pickupFilteredOptions.map((option) => (
                                        <li
                                            key={option.value}
                                            onClick={() => {
                                                if (!returnToDifferent) {
                                                    setPickupLocationId(option.value);
                                                    setReturnLocationId(option.value);
                                                } else {
                                                    setPickupLocationId(option.value);
                                                }
                                                setPickupSearch(option.label);
                                                setBranchId(option.branchId);
                                                setLocationFeeAmount(option?.locationFee);
                                                setTaxAmount(option?.tax);
                                                setMandatoryAdditionalChargesAmount(option?.mandatoryAdditionalCharges);
                                                setGovernmentTaxAmount(option?.governmentTax);
                                                setPickupIsFocused(false);
                                            }}
                                            className={`p-3 cursor-pointer bg-gray-100 border-b hover:bg-white hover:font-semibold ${webData?.hoverPrimaryTextColor}`}
                                        >
                                            {option.label}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>

                        {/* Return Location (if different) */}
                        {returnToDifferent && (
                            <div className="w-full space-y-2 relative" ref={returnWrapperRef}>
                                <label className="text-sm font-semibold">Return Location</label>
                                <div className="w-full border rounded-lg px-1 text-sm flex items-center">
                                    <input
                                        type="text"
                                        placeholder="Search Location"
                                        className="w-full outline-none px-4 py-3"
                                        value={returnSearch}
                                        onChange={(e) => setReturnSearch(e.target.value)}
                                        onFocus={() => setReturnIsFocused(true)}
                                        required
                                    />
                                    {
                                        returnSearch && (
                                            <button
                                                onClick={() => setReturnSearch("")}
                                                className="text-black mx-2"
                                            >
                                                <span className="material-symbols-outlined text-lg">
                                                    close
                                                </span>
                                            </button>
                                        )
                                    }

                                    {
                                        !locationDataIsLoaded && (
                                            <button
                                                type="button"
                                                className="mx-2"
                                            >
                                                <Loader />
                                            </button>        
                                        )
                                    }
                                </div>

                                {
                                    returnIsFocused && !locationDataIsLoaded && (
                                        <ul className="absolute z-10 mt-1 w-full bg-white border rounded-md shadow-lg max-h-52 overflow-y-auto text-sm">              
                                            <li className={`p-3 cursor-pointer bg-gray-100 border-b hover:bg-white hover:font-semibold ${webData?.hoverPrimaryTextColor}`}>
                                                Loading…
                                            </li>
                                        </ul>
                                    )
                                }

                                {returnIsFocused && returnFilteredOptions.length > 0 && (
                                    <ul className="absolute z-10 mt-1 w-full bg-white border rounded-md shadow-lg max-h-52 overflow-y-auto text-sm">
                                        {returnFilteredOptions.map((option) => (
                                            <li
                                                key={option.value}
                                                onClick={() => {
                                                    setReturnLocationId(option.value);
                                                    setReturnSearch(option.label);
                                                    setReturnIsFocused(false);
                                                }}
                                                className={`p-3 cursor-pointer bg-gray-100 border-b hover:bg-white hover:font-semibold ${webData?.textPrimaryColor}`}
                                            >
                                                {option.label}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        )}
                    </div>

                    {/* Checkbox */}
                    <div className="flex items-center space-x-2">
                        <input
                            id="return-diff"
                            type="checkbox"
                            className="w-5 h-5 text-blue-600 border-gray-300 rounded"
                            checked={returnToDifferent}
                            onChange={() => setReturnToDifferent(!returnToDifferent)}
                        />
                        <label htmlFor="return-diff" className="text-sm font-medium">
                            Return to a different location
                        </label>
                    </div>



                    <div className="flex flex-col lg:flex-row gap-6">
                        {/* Pickup */}
                        <div className="w-full lg:w-1/2">
                            <label className="block text-sm font-medium mb-1">Pickup Date & Time</label>
                            <div className="flex flex-col gap-2 md:flex-row md:gap-0">
                                <div className="relative w-full md:w-1/2">
                                    <CustomDateField
                                        value={pickupDate}
                                        onChange={(value) => {
                                            setPickupDate(value);
                                            if (new Date(value) >= new Date(returnDate)) {
                                                setReturnDate(moment(value).add(1, 'day').format('YYYY-MM-DD'));
                                            }
                                        }}
                                        dateFormat={webData?.dateFormat?.replace(/yyyy/g, 'YYYY')}
                                        minDate={new Date().toISOString().split("T")[0]}
                                        className="w-full px-4 py-[19px] border md:rounded-tr-none md:rounded-br-none md:rounded-tl-lg md:rounded-bl-lg rounded-lg flex items-center justify-between text-sm bg-white"
                                        showValidMessage={true}
                                        required={true}
                                    />
                                </div>
                                <div className="w-full md:w-1/2">
                                    <InputPicker
                                        type="time"
                                        inputRef={pickupTimeRef}
                                        inputValue={pickupTime}
                                        setInputValue={(inputValue) => setPickupTime(inputValue)}
                                        required
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Return */}
                        <div className="w-full lg:w-1/2">
                            <label className="block text-sm font-medium mb-1">Return Date & Time</label>
                            <div className="flex flex-col gap-2 md:flex-row md:gap-0">
                                <div className="relative w-full md:w-1/2">
                                    <CustomDateField
                                        value={returnDate}
                                        onChange={setReturnDate}
                                        dateFormat={webData?.dateFormat?.replace(/yyyy/g, 'YYYY')}
                                        minDate={pickupDate}
                                        className="w-full px-4 py-[19px] border md:rounded-tr-none md:rounded-br-none md:rounded-tl-lg md:rounded-bl-lg rounded-lg flex items-center justify-between text-sm bg-white"
                                        showValidMessage={true}
                                        required={true}
                                    />

                                </div>
                                <div className="w-full md:w-1/2">
                                    <InputPicker
                                        type="time"
                                        inputRef={returnTimeRef}
                                        inputValue={returnTime}
                                        setInputValue={(inputValue) => setReturnTime(inputValue)}
                                        required
                                    />
                                </div>
                            </div>

                            {returnTimeMessage && (
                                <p className="text-xs text-red-500 mt-1">{returnTimeMessage}</p>
                            )}
                            {minBookingMessage && (
                                <p className="text-xs text-red-500 mt-1">{minBookingMessage}</p>
                            )}
                        </div>
                    </div>

                    {/* Submit Button */}
                    <div className="md:w-full md:flex md:justify-end pt-4">
                        <button
                            type="submit"
                            className="w-full md:w-auto hover:opacity-90 text-white bg-primary font-semibold py-3 px-6 rounded-xl transition-all duration-200"
                            style={{ backgroundColor: webData?.websiteHeaderColor }}
                        >
                            Show Vehicles
                        </button>
                    </div>

                </form>
            </div>
        </header>

    );
}